import PropTypes from "prop-types";
import { ProductCollection } from "vino/components";

const Block = ({ attributes }) => {
	return <ProductCollection />;
};

Block.propTypes = {
	attributes: PropTypes.object,
};

export default Block;
